<template>
  <div class="">

    <div class="p-4 mb-8 bg-yellow-100 border border-yellow-500 text-base text-gray-800 rounded w-full lg:w-1/2" 
      v-if="broker.docusign_link != null && signElectronicLink">

      Before your loan application can be assessed, you need to complete and electronically sign the 
      Privacy &amp; Consent form (and other documents if requested). 
      By clicking, I also acknowledge that the information I have completed is true and correct.

      <div class="mt-4">
        <a :href="broker.docusign_link" target="_blank" 
          class="inline-block bg-indigo-500 text-white px-4 py-2 rounded text-sm font-semibold hover:bg-indigo-600">Click to Sign Electronically</a>
      </div>

      <div class="mt-2 text-gray-700 text-sm">
        You will be taken to an e-signature platform
      </div>
    </div>

    <div class="flex items-center">
      <div class="text-lg mr-4">
        Ready to send?
      </div>
    </div>
    
    <div class="my-8 w-full lg:w-1/2">
      
      <div class="px-4 pt-4 bg-gray-200 border border-gray-500 overflow-hidden text-sm" style="padding-bottom:14px;">
        <div class="float-left" style="margin-top:2px;">
          <img src="/static/img/icons/icons8-info.png" 
          style="width:18px;" />            
        </div>

        <div style="margin:-1px 0 0 28px;" class="leading-normal">
          Before you send the form back to your broker, 
          please complete all the required fields in all pages.
          Please also check that you have included all of the documents you need.
        </div>
      </div>

      <template v-for="(applicantDocuments, index) in documentsByApplicants">
        <div class="mt-8 text-xl font-thin border-b mb-2 pb-2">{{ applicantDocuments.applicantName }}</div>

        <template v-if="applicantDocuments.documents.length > 0">
          <template v-for="(document, documentIndex) in applicantDocuments.documents">
            <div class="mt-2 text-sm">{{ document.type }}</div>
          </template>
        </template>

        <template v-else>
          <div class="mt-2 text-sm text-gray-700">No documents</div>
        </template>
      </template>

      <div class="mt-12 mb-6">
        <button 
          v-on:click="submit" 
          class="text-white outline-none bg-blue-500 hover:bg-blue-600 inline-block overflow-hidden font-semibold text-sm" style="padding:15px 30px 13px 30px;">
          <div class="float-left">
            Send to broker
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/shared/components/headers/PageHeader'

  export default {

    components: {
      PageHeader
    },

    data () {
      return {
        broker               : this.$store.state.clientModule.broker,
        documentsByApplicants: null,
        signElectronicLink   : this.$store.state.clientModule.client.submit != null && this.$store.state.clientModule.client.submit.sign_electronic_link
      }
    },

    created() {    
      this.getDocuments()
    },

    methods : {

      getDocuments() {
        this.showLoader("Loading documents...")
        this.apiGet({
          clientId: this.$route.params.clientId,
        }, 'document/applicant-documents', (data) => {
          this.hideLoader()

          // organize the response by applicants
          let arr = []
          for(let i=0; i < this.$store.state[this.$store.state.view + 'Module'].client.applicants.length; i++) {
            let applicant = this.$store.state[this.$store.state.view + 'Module'].client.applicants[i]
            let documents = []

            for(let j=0; j < data.documents.length; j++) {
              if(data.documents[j].applicant_id == applicant.id) {
                documents.push(data.documents[j])
              }
            }

            arr.push({
              applicantName: this.getApplicantName(applicant),
              documents    : documents
            })
          }

          this.documentsByApplicants = arr
        })
      },

      // submit for this should save everything for the final time
      // and then take the user to the next tab, which is assets
      submit() {
        this.showLoader("Sending...")
        this.apiPost({
          clientId: this.$route.params.clientId,
        }, 'submit/submit-by-client', () => {
          this.hideLoader()
          this.$router.push({
            name : 'application-submitted'
          })          
        })
      },
    }
  }
</script>